import api from './api';

export const getLeaderboard = async (type, sortBy = 'total_revenue') => {
  const response = await api.get(`/performance/leaderboard/${type}?sortBy=${sortBy}&limit=20`);
  return response.data;
};
